/*
 * Created by fast networx on 10.07.2019
 * Copyright STRÖER Dialog Solutions GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../components/Header";
import TextBody from "../components/TextBody";
import Button from "@material-ui/core/es/Button/Button";
import {Col, Container, Row, Input} from "reactstrap";
import i18n from "i18next";
import genesys from "../api/genesys";
import {SpacerRow} from "../components/SpacerRow";
import BottomBarActive from "../components/BottomBarActive";
import BottomBar from "../components/BottomBar";
import TopNav from "../components/TopNav";
import TextField from '@material-ui/core/TextField';
import {BrowserView,MobileView, isMobile} from "react-device-detect";
import SubPageTopBar from "../components/SubPageTopBar";
import LoadingPage from "./LoadingPage";
import {STAGES} from "./Stage";
import iconSuccess from "../media/icons/success-check-red.png";

class Stage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            phoneNumber: "",
            submitting: false
        }
    }

    phoneNumberInputChanged = (event) => {
        this.setState({
            phoneNumber: event.target.value,
            error: ""
        })
    };

    render() {

        // TODO FooterLnk vorbereitet zum Einbau, wenn vom PO gewünscht
		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        let callBackConfirmTitle = isMobile ? "callback_confirm_title" : "callback_confirm_title";
        let callBackConfirmBody = isMobile ? "callback_confirm_body" : "callback_confirm_body";
        let callBackConfirmButton = isMobile ? "callback_confirm_button" : "callback_confirm_button";

        const successIconImage = <center><img src={iconSuccess} style={{width:"87px",height:"82px"}} alt={"success_icon"} /></center>;

        const callbackContent = <div>
            <SubPageTopBar
                progress={0}
                onClickClose={this.props.onClickClose}
            />
            <SpacerRow/>
            <Row style={{marginTop:"10%",marginBottom:"30px"}}>
                <Col>
                    {successIconImage}
                </Col>
            </Row>
            <Header
                textResource={callBackConfirmTitle}
            />
            <SpacerRow/>
            <TextBody
                textResource={callBackConfirmBody}
            />
            <SpacerRow/>
            <p>{this.state.error}</p></div>

        const bottomBarContent = <BottomBar
            mainButtonOnClick={this.props.onClickClose}
            mainButtonTextResource={callBackConfirmButton}
            showFullWidth={true}
        />;

        return <Container fluid={true} style={{backgroundColor:"white",height:"100%"}}>
            <MobileView>
                <SpacerRow/>
                {callbackContent}
                <span className={"fixed-to-bottom fixed-to-bottom-nomargin"}>
                    {bottomBarContent}
                </span>
            </MobileView>
            <BrowserView>
                <Container>
                    <Row>
                        <Col sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 3 }} lg={{ size: 4, offset: 4 }}>
                            {callbackContent}
                            <SpacerRow/>
                            {bottomBarContent}
                        </Col>
                    </Row>
                </Container>

            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage);